import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:stretch;}.ssr-plugin'
import '.ab{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.ac{border-radius:1.25rem;}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.b1{overflow-y:hidden;}.ssr-plugin'
import '.ei{padding:1rem 1.5rem;}.ssr-plugin'
import '.cq{background:var(--palette-white);}.ssr-plugin'
import '.y{justify-content:space-between;}.ssr-plugin'
import '.gj{padding:0rem 1.5rem 2rem;}.ssr-plugin'
import '.gk{max-height:80vh;}.ssr-plugin'
import '.ay{overflow-y:auto;}.ssr-plugin'
import '.dh{justify-content:flex-end;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ReactNode } from 'react'
import { Button } from '@app/components/core/button/Button'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import useMediaQuery from '@app/util/useMediaQuery'

export type ModalProps = {
  children: ReactNode
  isOpen: boolean
  title?: string
  loading?: boolean
  renderContainer?: HTMLElement
  onClose: () => void
  onConfirm?: () => void
  backLabel?: string
  confirmLabel?: string
}

export const Modal = ({
  children,
  isOpen,
  loading,
  title,
  renderContainer,
  onClose,
  onConfirm,
  backLabel,
  confirmLabel,
}: ModalProps) => {
  // Always call hooks first
  const translations = useTranslations().app.common
  const isMobile = useMediaQuery()
  // Early return after hooks
  if (!isOpen) {
    return null
  }
  const content = (
    <div className="d e aa ab ac ad b1"
      style={{
        maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',
      }}
    >
      <div className="d ei cq y"
      >
        <Title.H5>{title ?? translations.attention}</Title.H5>
        <CloseButton onClick={onClose} size="small" />
      </div>
      <div className="d e gj cq gk ay"
      >
        {children}
      </div>
      <div className="d ei cq dh g"
      >
        <Button
          label={backLabel ?? translations.back}
          onClick={onClose}
          variant="secondary"
        />
        {onConfirm && (
          <Button
            label={confirmLabel ?? translations.continue}
            onClick={onConfirm}
            disabled={loading}
          />
        )}
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
